module.exports = __webpack_public_path__ + "img/A+.528e3115.png";